import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./SkilledTutors.css"; // Custom styles
import { SkilledTutors } from "./../../constants";

const PrevArrow = ({ className, style, onClick }) => (
  <div className={`${className} custom-arrow`} style={{ ...style }} onClick={onClick}>
    <LeftOutlined style={{ fontSize: "24px", color: "#000" }} />
  </div>
);

const NextArrow = ({ className, style, onClick }) => (
  <div className={`${className} custom-arrow`} style={{ ...style }} onClick={onClick}>
    <RightOutlined style={{ fontSize: "24px", color: "#000" }} />
  </div>
);

const SkilledTutorsComponent = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="section-container">
      <div className="section-meet-tutors-title">
        Meet Our Highly <span className="highlight">Skilled Tutors</span>
      </div>

      <div className="small-section-meet-tutors-sub-title">
        Let's have a look to our expert and experienced home tutors and online tutors .
      </div>
      <div className="slider-container">
        <Slider {...settings}>
          {SkilledTutors.map((tutor, index) => (
            <div className="container">
              <div className="image-container">
                <img src={tutor.image} alt="User" className="user-image" />

                {/* <div className="badge">
                  <img src="badge-icon.png" alt="Badge Icon" width="30" />
                </div> */}

                {/* <div className="feedback">
                  <img src="Like-Icon.png" alt="Thumb Icon" className="thumb-icon" />
                  <span>{tutor.feedback}</span>
                </div> */}
              </div>

              <div className="tutor-details">
                <div className="stars">
                  {Array(5)
                    .fill()
                    .map((_, i) => (
                      <img src="/Star.png" alt="Star" key={i} className="star-icon" />
                    ))}
                </div>
                <h3>{tutor.name}</h3>
                <h4>{tutor.expertise}</h4>
                <p>{tutor.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default SkilledTutorsComponent;
